// Units of measure for parts. Quantities stay whole numbers; "pack ratio" = how many units come in one box you buy.
export const UOMS: [string, string][] = [
  ['each', 'Each'], ['pair', 'Pair'], ['set', 'Set'], ['kit', 'Kit'], ['box', 'Box'], ['case', 'Case'], ['pack', 'Pack'],
  ['gal', 'Gallon'], ['qt', 'Quart'], ['pt', 'Pint'], ['oz', 'Fluid oz'], ['l', 'Liter'], ['drum', 'Drum'],
  ['lb', 'Pound'], ['kg', 'Kilogram'], ['ft', 'Foot'], ['in', 'Inch'], ['m', 'Meter'], ['cm', 'Centimeter'], ['mm', 'Millimeter'],
  ['sqft', 'Square foot'], ['roll', 'Roll'], ['tube', 'Tube'], ['can', 'Can'], ['bottle', 'Bottle'],
];
export const UOM_KEYS = UOMS.map(u => u[0]);
/** "2", "2 gal", "3 ft" — "each" is left off. */
export const qtyUom = (qty: number, uom?: string | null) => (uom && uom !== 'each' ? `${qty} ${uom}` : String(qty));
